module.exports = require('./helpers/bundle-url').getBundleURL('kmvYf') + "mark-solms.71417677.png" + "?" + Date.now();